import React from 'react';

import { Flex, xcss } from '@atlaskit/primitives';

import { type FooterProps } from './types';

const flexStyles = xcss({
	width: '100%',
});

const Footer = ({ children }: FooterProps) => (
	<Flex alignItems="center" justifyContent="end" columnGap="space.050" xcss={flexStyles}>
		{children}
	</Flex>
);

export { Footer };
